export default __webpack_public_path__ + "static/media/Aubo Robotics.3ed7f094.png";